import {uniq} from 'underscore';

import BenchlingConfig from 'BenchlingConfig';
import {PLATE_SCHEMA_SIZE_OPTIONS, PlateSize} from 'samples/storables/StorableSchemaConstants';
/**
 * Returns the preset plate sizes for the tenant from the base options and the INVENTORY_CUSTOM_PLATE_SIZES
 * flag. Sorted in descending size order.
 *
 * Optionally can override the default sizes.
 */
export default function getPresetPlateSizes(
  defaultSizes: Array<PlateSize> = PLATE_SCHEMA_SIZE_OPTIONS
): Array<PlateSize> {
  const customSizes: Array<PlateSize> = BenchlingConfig.INVENTORY_CUSTOM_PLATE_SIZES.map((customSize) => [
    customSize.rows,
    customSize.columns,
  ]);
  const allSizes = defaultSizes.concat(customSizes);
  // Deduplicate and sort by number of wells descending (or number of rows descending)
  return uniq<PlateSize, string>(allSizes, (size) => size.join(',')).toSorted(
    ([sizeRowsA, sizeColumnsA], [sizeRowsB, sizeColumnsB]) => {
      const numWellsA = sizeRowsA * sizeColumnsA;
      const numWellsB = sizeRowsB * sizeColumnsB;
      if (numWellsB !== numWellsA) {
        return numWellsB - numWellsA;
      }
      return sizeRowsB - sizeRowsA;
    }
  );
}
